<template>
  <div>
    <v-card class="py-4">
      <v-row justify="end" class="ma-0 pr-4" align="center">
        <v-btn text color="red" @click="close" id="revision-dialog-close-button">
          close
          <v-icon right> {{ icon.mdiClose }} </v-icon>
        </v-btn>
      </v-row>
      <v-card-title class="mx-4">{{ paper.title }}</v-card-title>
      <v-divider class="mx-8 mb-8" />
      <v-row class="ma-0 px-2">
        <v-col cols="12" lg="6" md="6" sm="6" xs="12">
          <div class="subtitle-2 px-4 pt-6">Reviews</div>
          <v-row class="ma-0 mt-4">
            <v-col cols="12" lg="10" md="10" sm="10" xs="10">
              <v-select
                id="revision-dialog-add-reviewer-select"
                v-model="selectedUser"
                outlined
                placeholder="Add reviewer"
                :items="unassignedReviewers"
                item-text="email"
                return-object
                dense
              />
            </v-col>
            <v-col cols="12" lg="2" md="2" sm="2" xs="2">
              <v-btn color="blue" dark @click="addReviewer" id="revision-dialog-add-reviewer-button"
                >add
                <v-icon>{{ icon.mdiPlus }}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-list>
            <div v-for="(review, i) in paper.state.reviews" :key="i">
              <review-card
                :review="review"
                :reviews="paper.state.reviews"
                :paper="paper"
                @removeReviewer="removeReviewer"
              />
            </div>
          </v-list>
        </v-col>
        <v-col cols="12" lg="6" md="6" sm="6" xs="12">
          <v-card color="grey lighten-4 pa-4 mx-2" rounded flat height="100%">
            <div class="subtitle-2 px-4 pt-2">Approval</div>
            <paper-approval :paper="paper" />
          </v-card>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
import PaperApproval from "@/components/atoms/paper/PaperApproval.vue";
import ReviewCard from "@/components/atoms/paper/ReviewCard.vue";
import { mdiClose, mdiPlus } from "@mdi/js";
import paper from "@/helpers/paperStatus.js";

export default {
  components: { ReviewCard, PaperApproval },
  props: ["paper"],
  data: () => ({
    icon: {
      mdiClose,
      mdiPlus,
    },
    selectedUser: "",
  }),
  methods: {
    close() {
      this.$emit("close");
    },
    async addReviewer() {
      let review = {
        status: "Under Review",
        reviewerName: this.selectedUser.displayName,
        reviewerImg: "",
        revisionDate: new Date().toLocaleString("en-US"),
        review: "",
      };

      //same as -> this.paper.state.reviews[this.selectedUser.id] = Object.assign({}, review);
      //needs this to make v-for update
      this.$set(
        this.paper.state.reviews,
        this.selectedUser.id,
        Object.assign({}, review)
      );

      //create newPaper object without paper id
      let newPaper = {};
      Object.assign(
        {},
        Object.keys(this.paper).forEach((key) => {
          if (key !== "id") newPaper[key] = this.paper[key];
        })
      );

      //add reviewer to paper
      await this.$store
        .dispatch("updatePaper", {
          id: this.paper.id,
          data: newPaper,
        })
        .then(() => {
          this.$store.dispatch("updateChangeLogs", {
            paperId: this.paper.id,
            log: {
              label: `${
                paper.changeLog("","")[
                  "reviewerAssigned"
                ].label
              }`,
              datetime: new Date().toLocaleString("en-US"),
            },
          });
        });

      //add paper to reviewer array
      await this.$store.dispatch("addToReviewId", {
        id: this.selectedUser.id,
        element: this.paper.id,
      });

      this.selectedUser = ""; //reset selected user
    },
    async removeReviewer(id) {
      this.$delete(this.paper.state.reviews, id);

      let newPaper = {};
      Object.assign(
        {},
        Object.keys(this.paper).forEach((key) => {
          if (key !== "id") newPaper[key] = this.paper[key];
        })
      );

      //add reviewer to paper
      await this.$store.dispatch("updatePaper", {
        id: this.paper.id,
        data: newPaper,
      });
    },
  },
  computed: {
    users() {
      return this.$store.getters.getUsers || [];
    },
    reviewers() {
      return this.users.filter((user) => user.roles.includes("rev"));
    },
    currentReviewers() {
      return Object.keys(this.paper?.state?.reviews); //get current reviewers ids
    },
    unassignedReviewers() {
      return this.reviewers.filter(
        (user) => !this.currentReviewers.includes(user.id)
      );
    },
  },
  async created() {
    if (!this.$store.getters.getUsers) this.$store.dispatch("getAllUsers");
  },
};
</script>